<template>
    <div class="inviteAccount flex align-cen" id="inviteAccount">
        <div class="inviteAccount_container">
            <div class="head">
                <div class="title">
                    邀请成员
                </div>
            </div>
            <div class="container">
                <div class="avatar_box">
                    <img :src="propList.avatar || require('../../assets/images/user.png')" alt="">
                </div>
                <div class="username">
                    {{propList.shareName}}  邀请你加入
                </div>
                <div class="buname">
                    【{{this.businessInfo.name}}】
                </div>
                <div class="btm_btn_box flex align-cen">
                    <div class="fai_submit_btn btn" @click="joinTeam">加入</div>
                    <div class="fai_cancel_btn btn" @click="openIndex">取消</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getCurrentUser,getBusiness,inviteAccount,enBusiness} from "@/api/enterprise/index"; // 获取当前成员信息、团队信息、邀请成员
export default {
    name:'inviteAccount',
    data() {
        return {
            propList:{},
            businessInfo:{},
            currintuserInfo:{}
        }
    },
    created () {
        const token = this.$locaStorage.setAge().get('token1')
        if(token){
        // let decryptQuery=decodeURIComponent(this.$route.query.dataJson); // 解密
        // console.log(decryptQuery)
        this.propList = JSON.parse(this.$route.query.dataJson)
        console.log(this.propList)
        this.getDetail()
        // console.log()
        }else{
             this.$util.Notifi('请先登录','error','fa-exclamation-circle'); 
             this.$router.replace({
                name:'enLogin',
                query:{
                    dataJson:this.$route.query.dataJson
                }
             })
        }
    },
    methods: {
        // 取消操作
        openIndex(){
            this.$router.push('/webenterprise/homePage')
        },
             // 获取当前用户信息
        // getUserInfo(){
        //      getCurrentUser({
        //         id:this.propList.businessId
        //       },'enterprise')
        //     .then(res => {
        //      this.currintuserInfo = res.data.user_info
        //     })
        // },
          // 获取详情
        getDetail(){
             getBusiness({
                id:this.propList.businessId
              },'enterprise')
            .then(res => {
                this.businessInfo = res.data
                this.getInfo()
            })
        },
         // 获取企业列表
        getInfo(){
            enBusiness({},'enterprise')
           .then(res => {
            for (const key in res.data) {
               if(res.data[key].id == this.propList.businessId){
                this.$util.Notifi('已加入该团队～～～','success','fa-check')
                  let businessInfo = {
                    id:this.businessInfo.id,
                    logo:this.businessInfo.logo,
                    name:this.businessInfo.name,
                    phone:this.businessInfo.phone
                }
                        localStorage.removeItem('businessInfo')
                        this.$locaStorage.setAge().set('businessInfo',businessInfo)
                        this.$router.replace({
                            name:'webenterpriseManage',
                        })
               }
            }
           })
           .catch(err => {
           })
        },
        // 加入
        joinTeam(){
            let params = {
                businessId:this.propList.businessId,
                isAdmin:this.propList.isAdmin,
                appIds:this.propList.appIds,
                startTime:this.propList.nowDate,
                groupIds:this.propList.groupIds
            }
              inviteAccount(params,'enterprise')
            .then(res => {
                if(res.code == 0){
                  this.$util.Notifi('加入成功','success','fa-check')
                let businessInfo = {
                    id:this.businessInfo.id,
                    logo:this.businessInfo.logo,
                    name:this.businessInfo.name,
                    phone:this.businessInfo.phone
                }
            localStorage.removeItem('businessInfo')
            this.$locaStorage.setAge().set('businessInfo',businessInfo)
            if(this.$util.isMobile()){
                   this.$router.push('/webenterprise/adminMobileTransfer')
            }else{
                 this.$router.push({
                name:'webenterpriseManage',
            })
            }
                }else{
                     this.$util.Notifi(res.msg,'error','fa-exclamation-circle'); 
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.inviteAccount{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: #f5f6fa;
    position: relative;
    .inviteAccount_container{
    position: relative;
    margin: 0 auto;
    width: 600px;
    background-color: #fff;
    box-shadow: 0 0 7px 0 rgba(197, 197, 197, 0.34);
    padding: 40px 55px;
    box-sizing: border-box;
    .head{
       height: 72px;
    line-height: 95px;
    padding: 0 17px 0 33px;
    border-bottom: 1px solid #eaeaea;
    box-sizing: content-box; 
    }
    .container{
           padding: 20px 40px 30px; 
           text-align: center;
           .avatar_box{
            position: relative;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin: 0 auto;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
           }
           .username{
            font-weight: 800;
            margin: 20px 0;
            font-size: 15px;
           }
           .buname{
            color: #2893f1;
            font-weight: 800;
           }
           .btm_btn_box{
            margin-top: 30px;
            justify-content: center;
            .btn{
                width: 120px;
                height: 40px;
                line-height: 40px;
                background: white;
                border-radius: 2px;
                box-sizing: content-box;
                font-size: 16px;
                cursor: pointer;
                transition: all 0.3s linear;
                text-align: center;
            }
            .fai_submit_btn{
                border: 1px solid #0157ff;
                color: #0157ff;
            }
            .fai_cancel_btn{
                border: 1px solid #dadada;
            color: #90909e;
            margin-left: 30px;
            }
           }
    }
    }
}
@media (max-width: 640px){
    #inviteAccount{
        margin-top: -56px;
        .inviteAccount_container{
            width: 90%;
        }
    }
}
</style>